/* ---------------------------------------------------------------------------
   Bottega d'Arte Stringa — i filtri sopra la griglia di una collezione.
   Chiesto il 15/09/2026: marchio, tipologia e prezzo da-a.

   Come si usa in una pagina di collezione:

     <div data-filtri></div>      <- subito PRIMA della griglia
     <div class="grid"> ...card... </div>
     <script src="_filtri.js" defer></script>

   Le opzioni non sono scritte a mano: si ricavano dalle card presenti. Una
   collezione con tre marchi mostra tre marchi, e quando queste pagine andranno
   sul tema Shopify con il catalogo vero i menu si riempiranno da soli, senza
   che nessuno torni qui a elencare 1.200 prodotti.

   Il marchio si legge da data-marchio, e in mancanza dal .card-brand gia' in
   pagina; la tipologia da data-tipo.

   Il prezzo non ha fasce decise da noi: due cursori, da e a. Partono da 0 e
   arrivano al DOPPIO del pezzo piu' caro della pagina, non al pezzo piu' caro:
   se domani in collezione entra qualcosa che costa di piu', resta dentro al
   cursore invece di sparire da una ricerca che nessuno ha toccato.
   --------------------------------------------------------------------------- */
(function () {
  "use strict";

  var ganci = [].slice.call(document.querySelectorAll("[data-filtri]"));
  if (!ganci.length) return;

  var css = document.createElement("style");
  css.textContent = [
    ".avf{max-width:1180px;margin:0 auto 22px}",
    // chiuso si vede solo questa riga: il bottone e quanti pezzi ci sono
    ".avf-testa{display:flex;align-items:center;gap:12px}",
    ".avf-apri{display:inline-flex;align-items:center;gap:8px;padding:10px 15px;cursor:pointer;",
    "border:1px solid var(--line,#E3DDCE);border-radius:999px;background:var(--surface,#fff);",
    "color:var(--ink,#12363F);font-family:'DM Sans',Arial,sans-serif;font-size:12px;font-weight:600;",
    "letter-spacing:.06em;text-transform:uppercase}",
    ".avf-apri:hover{border-color:var(--ink,#12363F)}",
    ".avf-apri[aria-expanded=\"true\"]{background:var(--ink,#12363F);color:#fff;border-color:var(--ink,#12363F)}",
    ".avf-apri .icona{width:13px;height:13px;flex:none}",
    ".avf-apri .quanti{display:inline-flex;align-items:center;justify-content:center;min-width:17px;height:17px;",
    "padding:0 5px;border-radius:999px;background:var(--brass,#A9824A);color:#fff;font-size:10px}",
    // senza questa, la regola qui sopra batte l'attributo hidden e il pallino
    // resta a schermo con dentro uno zero
    ".avf-apri .quanti[hidden]{display:none}",
    ".avf-corpo{display:none;margin-top:12px;padding:14px 16px;background:var(--surface,#fff);",
    "border:1px solid var(--line,#E3DDCE);border-radius:6px}",
    ".avf-corpo.aperto{display:block}",
    ".avf-riga{display:flex;gap:14px;align-items:flex-end;flex-wrap:wrap}",
    ".avf-campo{display:flex;flex-direction:column;gap:5px;flex:1 1 170px;min-width:0}",
    ".avf-campo label{font-family:'DM Sans',Arial,sans-serif;font-size:10.5px;letter-spacing:.09em;",
    "text-transform:uppercase;color:var(--ink-soft,#54666B)}",
    ".avf-campo select{width:100%;padding:10px 11px;border:1px solid var(--line,#E3DDCE);border-radius:4px;",
    "background:var(--cream,#FAF9F4);color:var(--ink,#12363F);font-family:inherit;font-size:14px;cursor:pointer}",
    ".avf-campo select:focus{outline:2px solid var(--brass,#A9824A);outline-offset:1px}",
    ".avf-azzera{padding:10px 14px;border:1px solid var(--ink,#12363F);border-radius:4px;background:transparent;",
    "color:var(--ink,#12363F);font-family:'DM Sans',Arial,sans-serif;font-size:11px;letter-spacing:.07em;",
    "text-transform:uppercase;font-weight:600;cursor:pointer;flex:none}",
    ".avf-azzera:hover{background:var(--ink,#12363F);color:#fff}",
    ".avf-azzera[hidden]{display:none}",
    ".avf-conta{font-family:'DM Sans',Arial,sans-serif;font-size:12.5px;color:var(--ink-soft,#54666B)}",
    // i due cursori stanno uno sopra l'altro sulla stessa barra: si disegna la
    // barra col contenitore e si rendono trasparenti i track nativi
    ".avf-slider{position:relative;height:34px;margin-top:2px}",
    ".avf-slider .binario{position:absolute;top:15px;left:0;right:0;height:3px;border-radius:3px;",
    "background:var(--line,#E3DDCE)}",
    ".avf-slider .pieno{position:absolute;top:15px;height:3px;border-radius:3px;background:var(--brass,#A9824A)}",
    ".avf-slider input{position:absolute;top:6px;left:0;width:100%;margin:0;height:22px;background:none;",
    "-webkit-appearance:none;appearance:none;pointer-events:none}",
    ".avf-slider input:focus{outline:none}",
    ".avf-slider input::-webkit-slider-thumb{-webkit-appearance:none;pointer-events:auto;width:18px;height:18px;",
    "border-radius:50%;background:var(--cream,#FAF9F4);border:2px solid var(--brass,#A9824A);cursor:grab;",
    "box-shadow:0 1px 3px rgba(0,0,0,.18)}",
    ".avf-slider input::-moz-range-thumb{pointer-events:auto;width:16px;height:16px;border-radius:50%;",
    "background:var(--cream,#FAF9F4);border:2px solid var(--brass,#A9824A);cursor:grab;",
    "box-shadow:0 1px 3px rgba(0,0,0,.18)}",
    ".avf-slider input:focus-visible::-webkit-slider-thumb{outline:2px solid var(--brass,#A9824A);outline-offset:2px}",
    ".avf-prezzo-val{font-family:'DM Sans',Arial,sans-serif;font-size:13px;color:var(--ink,#12363F);font-weight:600}",
    ".avf-nulla{max-width:1180px;margin:0 auto 24px;padding:26px 18px;text-align:center;",
    "border:1px dashed var(--line,#E3DDCE);border-radius:6px;color:var(--ink-soft,#54666B);font-size:14px}",
    "@media(max-width:700px){.avf-riga{gap:10px}.avf-campo{flex:1 1 100%}.avf-azzera{width:100%}}"
  ].join("");
  document.head.appendChild(css);

  function testoDi(n) { return n ? (n.textContent || "").trim() : ""; }

  // "€760,00" -> 760 ; "<span class=old>€85,00</span> €68,00" -> 68 (conta il
  // prezzo che si paga, non quello sbarrato)
  function prezzoDi(card) {
    var nodo = card.querySelector(".card-price");
    if (!nodo) return null;
    var copia = nodo.cloneNode(true);
    var vecchio = copia.querySelector(".old");
    if (vecchio) vecchio.parentNode.removeChild(vecchio);
    var t = (copia.textContent || "").replace(/[^\d.,]/g, "");
    if (!t) return null;
    if (t.indexOf(",") > -1) t = t.replace(/\./g, "").replace(",", ".");
    var n = parseFloat(t);
    return isNaN(n) ? null : n;
  }

  function marchioDi(card) {
    var d = card.getAttribute("data-marchio");
    if (d != null && d !== "") return d.trim();
    return testoDi(card.querySelector(".card-brand"));
  }

  function tipoDi(card) { return (card.getAttribute("data-tipo") || "").trim(); }

  // il titolo senza l'etichetta "esempio" che sta dentro al nome nelle anteprime
  function titoloDi(card) {
    var nodo = card.querySelector(".card-title");
    if (!nodo) return "";
    var copia = nodo.cloneNode(true);
    [].slice.call(copia.querySelectorAll(".example-tag")).forEach(function (n) {
      n.parentNode.removeChild(n);
    });
    return (copia.textContent || "").trim();
  }

  var ORDINI = [
    { valore: "az", testo: "Nome, dalla A alla Z" },
    { valore: "za", testo: "Nome, dalla Z alla A" },
    { valore: "su", testo: "Prezzo, dal più basso" },
    { valore: "giu", testo: "Prezzo, dal più alto" }
  ];

  function euro(n) {
    return Math.round(n).toLocaleString("it-IT") + " €";
  }

  function el(tag, cls, testo) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (testo != null) n.textContent = testo;
    return n;
  }

  function campo(etichetta, id) {
    var c = el("div", "avf-campo");
    var l = el("label", null, etichetta);
    l.setAttribute("for", id);
    var s = document.createElement("select");
    s.id = id;
    c.appendChild(l); c.appendChild(s);
    return { radice: c, select: s };
  }

  function riempi(select, voceTutti, valori) {
    select.innerHTML = "";
    var tutti = document.createElement("option");
    tutti.value = ""; tutti.textContent = voceTutti;
    select.appendChild(tutti);
    valori.forEach(function (v) {
      var o = document.createElement("option");
      o.value = v.valore; o.textContent = v.testo;
      select.appendChild(o);
    });
  }

  ganci.forEach(function (gancio, indice) {
    var griglia = gancio.nextElementSibling;
    while (griglia && griglia.className.indexOf("grid") === -1) griglia = griglia.nextElementSibling;
    if (!griglia) return;

    var carte = [].slice.call(griglia.querySelectorAll(".card"));
    if (carte.length < 2) return;   // con un pezzo solo un filtro non serve a niente

    var dati = carte.map(function (c, posizione) {
      return {
        card: c,
        marchio: marchioDi(c),
        tipo: tipoDi(c),
        prezzo: prezzoDi(c),
        nome: titoloDi(c),
        posizione: posizione,
        esaurito: /(^|\s)esaurito(\s|$)/.test(c.className)
      };
    });

    var unici = function (chiave) {
      var visti = [];
      dati.forEach(function (d) {
        if (d[chiave] && visti.indexOf(d[chiave]) === -1) visti.push(d[chiave]);
      });
      return visti.sort(function (a, b) { return a.localeCompare(b, "it"); })
        .map(function (v) { return { valore: v, testo: v }; });
    };

    var marchi = unici("marchio");
    var tipi = unici("tipo");

    var prezzi = dati.map(function (d) { return d.prezzo; })
      .filter(function (p) { return p != null; });
    var minimo = prezzi.length ? 0 : null;
    var massimo = null, passo = 1;
    if (prezzi.length) {
      var piuCaro = Math.max.apply(null, prezzi);
      passo = piuCaro <= 200 ? 1 : (piuCaro <= 2000 ? 5 : 10);
      // il doppio, arrotondato in su a un multiplo del passo: cosi' l'estremo
      // destro e' sempre raggiungibile trascinando
      massimo = Math.ceil((piuCaro * 2) / passo) * passo;
    }

    var scatola = el("div", "avf");
    var corpo = el("div", "avf-corpo");
    corpo.id = "avf-corpo" + indice;
    var riga = el("div", "avf-riga");
    var cM = campo("Marchio", "avf-m" + indice);
    var cT = campo("Tipologia", "avf-t" + indice);

    riempi(cM.select, "Tutti i marchi", marchi);
    riempi(cT.select, "Tutte le tipologie", tipi);

    if (marchi.length) riga.appendChild(cM.radice);
    if (tipi.length) riga.appendChild(cT.radice);

    // Il prezzo: due cursori sulla stessa barra, da e a. Senza prezzi leggibili,
    // o con tutti i pezzi allo stesso prezzo, non si mostra: non c'e' niente da
    // scegliere.
    var daInput = null, aInput = null, valore = null, pieno = null;
    if (minimo != null && massimo != null && massimo > minimo) {
      var cP = el("div", "avf-campo");
      var etichetta = el("label", null, "Prezzo");
      valore = el("span", "avf-prezzo-val");
      var testa = el("div");
      testa.style.cssText = "display:flex;align-items:baseline;gap:8px;justify-content:space-between";
      testa.appendChild(etichetta); testa.appendChild(valore);

      var slider = el("div", "avf-slider");
      var binario = el("div", "binario");
      pieno = el("div", "pieno");
      daInput = document.createElement("input");
      aInput = document.createElement("input");
      [daInput, aInput].forEach(function (s, i) {
        s.type = "range";
        s.min = minimo; s.max = massimo; s.step = passo;
        s.value = i === 0 ? minimo : massimo;
        s.setAttribute("aria-label", i === 0 ? "Prezzo minimo" : "Prezzo massimo");
      });
      slider.appendChild(binario); slider.appendChild(pieno);
      slider.appendChild(daInput); slider.appendChild(aInput);
      cP.appendChild(testa); cP.appendChild(slider);
      cP.style.flex = "1 1 240px";
      riga.appendChild(cP);
    }

    var cO = campo("Ordina per", "avf-o" + indice);
    riempi(cO.select, "Ordine della collezione", ORDINI.filter(function (o) {
      // senza prezzi leggibili, ordinare per prezzo non vuol dire niente
      return (o.valore !== "su" && o.valore !== "giu") || prezzi.length;
    }));
    riga.appendChild(cO.radice);

    if (!riga.children.length) return;

    var azzera = el("button", "avf-azzera", "Azzera");
    azzera.type = "button";
    azzera.hidden = true;
    riga.appendChild(azzera);

    // La testa: chiusa occupa una riga sola. Su mobile la barra aperta si
    // mangiava mezza schermata prima di far vedere un solo prodotto.
    var testa = el("div", "avf-testa");
    var apri = el("button", "avf-apri");
    apri.type = "button";
    apri.setAttribute("aria-expanded", "false");
    apri.setAttribute("aria-controls", corpo.id);
    apri.innerHTML =
      '<svg class="icona" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" aria-hidden="true"><path d="M3 5h18M6 12h12M10 19h4"/></svg>' +
      '<span>Filtri</span>';
    var quanti = el("span", "quanti");
    quanti.hidden = true;
    apri.appendChild(quanti);

    var conta = el("span", "avf-conta");
    testa.appendChild(apri);
    testa.appendChild(conta);

    corpo.appendChild(riga);
    scatola.appendChild(testa);
    scatola.appendChild(corpo);
    gancio.appendChild(scatola);

    apri.addEventListener("click", function () {
      var aperto = corpo.classList.toggle("aperto");
      apri.setAttribute("aria-expanded", aperto ? "true" : "false");
    });

    var nulla = el("div", "avf-nulla", "Nessun pezzo con questi filtri. Prova ad allargare la ricerca.");
    nulla.hidden = true;
    griglia.parentNode.insertBefore(nulla, griglia.nextSibling);

    // I pezzi esauriti restano in fondo comunque, anche ordinando: e' la regola
    // della griglia (non rubano il posto a quelli comprabili), e un "prezzo dal
    // piu' basso" che apre con un esaurito manda la persona su un vicolo cieco.
    function ordina(come) {
      var ordinati = dati.slice();
      if (come === "az" || come === "za") {
        ordinati.sort(function (x, y) {
          var c = x.nome.localeCompare(y.nome, "it", { sensitivity: "base" });
          return come === "az" ? c : -c;
        });
      } else if (come === "su" || come === "giu") {
        ordinati.sort(function (x, y) {
          if (x.prezzo == null) return 1;
          if (y.prezzo == null) return -1;
          return come === "su" ? x.prezzo - y.prezzo : y.prezzo - x.prezzo;
        });
      } else {
        ordinati.sort(function (x, y) { return x.posizione - y.posizione; });
      }
      ordinati.sort(function (x, y) { return (x.esaurito ? 1 : 0) - (y.esaurito ? 1 : 0); });
      ordinati.forEach(function (d) { griglia.appendChild(d.card); });
    }

    function applica() {
      var m = cM.select.value, t = cT.select.value;
      var da = daInput ? +daInput.value : null;
      var a = aInput ? +aInput.value : null;
      var prezzoTocco = daInput && (da > minimo || a < massimo);

      if (daInput) {
        valore.textContent = euro(da) + " – " + euro(a);
        pieno.style.left = ((da - minimo) / (massimo - minimo) * 100) + "%";
        pieno.style.right = ((massimo - a) / (massimo - minimo) * 100) + "%";
      }

      var visibili = 0;
      dati.forEach(function (d) {
        var ok = (!m || d.marchio === m) && (!t || d.tipo === t) &&
          (!prezzoTocco || (d.prezzo != null && d.prezzo >= da && d.prezzo <= a));
        d.card.hidden = !ok;
        if (ok) visibili++;
      });

      ordina(cO.select.value);

      var attivi = !!(m || t || prezzoTocco || cO.select.value);

      // col pannello chiuso, il pallino sul bottone e' l'unico modo per sapere
      // che la griglia e' filtrata
      var quantiAttivi = (m ? 1 : 0) + (t ? 1 : 0) + (prezzoTocco ? 1 : 0) + (cO.select.value ? 1 : 0);
      quanti.hidden = quantiAttivi === 0;
      quanti.textContent = quantiAttivi;
      azzera.hidden = !attivi;
      nulla.hidden = visibili !== 0;
      var pezzi = function (n) { return n === 1 ? "1 pezzo" : n + " pezzi"; };
      conta.textContent = attivi
        ? pezzi(visibili) + " su " + dati.length
        : pezzi(dati.length);
    }

    [cM.select, cT.select, cO.select].forEach(function (s) {
      s.addEventListener("change", applica);
    });

    if (daInput) {
      // i due cursori non si scavalcano: chi spinge oltre l'altro si ferma
      daInput.addEventListener("input", function () {
        if (+daInput.value > +aInput.value) daInput.value = aInput.value;
        applica();
      });
      aInput.addEventListener("input", function () {
        if (+aInput.value < +daInput.value) aInput.value = daInput.value;
        applica();
      });
    }

    azzera.addEventListener("click", function () {
      cM.select.value = ""; cT.select.value = ""; cO.select.value = "";
      if (daInput) { daInput.value = minimo; aInput.value = massimo; }
      applica();
    });

    applica();
  });
})();
